import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import { useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ShowAppBar } from "../../Redux/Action";
import { useDispatch, useSelector } from "react-redux";
import { setJsonReturn } from "../../Redux/Action";
import { useEffect } from "react";
import { fetchReturnData } from "../Services/api";
import { CircularProgress } from "@mui/material";
const Returns = (props) => {
  const [showdetails, setShowDetails] = useState(false);
  const [selectedTick, setselectedTick] = useState(null);
  const selectIndicator = useSelector((state) => state.SelectedDropdownOption);
  const selectedExchange = useSelector((state) => state.SetExchange);
  const selecttimeFrame = useSelector((state) => state.ActiveButton);
  const jsonData = useSelector((state) => state.jsonReturns);
  const serachValue = useSelector((state) => state.searchvalue);
    const isLoading = useSelector((state) => state.isLoading);

  const [filterData, setfilterData] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectIndicator === "Returns") {
      fetchReturnData(selectedExchange, dispatch, setJsonReturn);
    }
  }, [selecttimeFrame, selectedExchange, selectIndicator, dispatch]);

  const handleShowDetails = (details) => {
    setselectedTick(details);
    setShowDetails(true);
    dispatch(ShowAppBar(true));
  };

  const handleShowDetails1 = () => {
    setselectedTick(null);
    setShowDetails(false);
    dispatch(ShowAppBar(false));
  };
  // Function to filter array data
  const filterArrayData = (dataArray) => {
    return dataArray.filter((item) =>
      item.Ticker.trim()
        .toLowerCase()
        .includes(serachValue.trim().toLowerCase())
    );
  };
  const filterObjectData = (dataObject) => {
    if (dataObject && dataObject.Data) {
      return dataObject.Data.filter(
        (item) =>
          serachValue &&
          item.Ticker &&
          item.Ticker.trim()
            .toLowerCase()
            .includes(serachValue.trim().toLowerCase())
      );
    }
    return [];
  };
  const getFilteredData = () => {

    if (!jsonData) {
      return [];
    }

    if (Array.isArray(jsonData)) {
      return filterArrayData(jsonData);
    } else if (typeof jsonData === "object") {
      return filterObjectData(jsonData);
    }

    return [];
  };

  useEffect(() => {
    if (serachValue === "") {
      setfilterData(jsonData.Data);
    } else {
      setfilterData(getFilteredData());
    }
  }, [jsonData, serachValue]);

  return (
    isLoading ? 
    <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'50vh'}}>
<CircularProgress />

    </div>
    :
    <div>
      {!showdetails ? (
        <Card style={{ height: "100vh" }}>
          <CardContent
            style={{
              alignItems: "center",
              height: "80vh",
              overflowY: "auto",
            }}
          >
            <div
              style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "80",
                  fontWeight: "bold",
                  padding: "0px 0px 10px 0px",
                  position: "sticky",
                  top: "0",
                  color: "grey",
                  backgroundColor: "white",
                  zIndex: "1",
                }}
              >
                <div style={{ flex: "1" }}>Symbol</div>
                <div style={{ flex: "1" }}>1DChg%</div>
                {/* <div style={{ flex: "1" }}>1WChg%</div> */}
              </div>
              <div style={{ flex: "1", overflowY: "auto" }}>
                {filterData &&
                  filterData.length !== 0 &&
                  filterData.map((retrundata, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "16px",
                        borderBottom: "1px solid grey",
                        padding: "20px 0px 20px 0px",
                      }}
                    >
                      <div style={{ flex: "1", padding: "0 10px" }}>
                        <a href={`https://www.google.com/finance/quote/${retrundata.Ticker}:${selectedExchange}?hl=en`} target="_blank" rel="noopener noreferrer">{retrundata.Ticker}</a>
                        
                      </div>
                      <div style={{ flex: "1", padding: "0 10px" }}>
                        {retrundata.Values[0]}
                      </div>
                      {/* <div style={{ flex: "1", padding: "0 10px" }}>
                        {retrundata.Values[1]}
                      </div> */}
                      <div onClick={() => handleShowDetails(retrundata)}>
                        <ChevronRightIcon />
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            {/* ))} */}
          </CardContent>
        </Card>
      ) : null}

      {showdetails ? (
        <Card
          style={{
            border: "1px solid green",
            height: "99vh",
            overflowY: "auto",
          }}
        >
          <div>
            <div>
              <Button
                style={{
                  display: "flex",
                  fontWeight: "bold",
                  fontSize: "medium",
                }}
                onClick={() => handleShowDetails1()}
              >
                Close
              </Button>
            </div>
          </div>
          <CardContent>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <h3 >{selectedTick.Ticker}</h3>
            </div>
            <div
              style={{
                fontSize: "16px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>OneDay</div>
                <div>{selectedTick.Values[0]}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>OneWeek</div>
                <div>{selectedTick.Values[1]}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>OneMonth</div>
                <div> {selectedTick.Values[2]}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>ThreeMonth</div>
                <div> {selectedTick.Values[3]}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>SixMonth</div>
                <div>{selectedTick.Values[4]}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>OneYear</div>
                <div>{selectedTick.Values[5]}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>ThreeYear</div>
                <div>{selectedTick.Values[6]}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>FiveYear</div>
                <div>{selectedTick.Values[7]}</div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>MaxYear</div>
                <div>{selectedTick.Values[8]}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div style={{ textAlign: "left" }}>YearToDate</div>
                <div style={{ textAlign: "right" }}>
                  {selectedTick.Values[9]}
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      ) : null}
    </div>
  );
};

export default Returns;
